import { render, staticRenderFns } from "./authorizationinfo.vue?vue&type=template&id=15227ac3&scoped=true&"
import script from "./authorizationinfo.vue?vue&type=script&lang=js&"
export * from "./authorizationinfo.vue?vue&type=script&lang=js&"
import style0 from "./authorizationinfo.vue?vue&type=style&index=0&id=15227ac3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15227ac3",
  null
  
)

export default component.exports